"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EnIdIdr = exports.IdIdIdr = void 0;
class IdIdIdr {
    constructor() {
        this.locale = "id-id";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "d MMMM yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "IDR",
            symbol: "Rp",
            decimalSeparator: "",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.IdIdIdr = IdIdIdr;
class EnIdIdr {
    constructor() {
        this.locale = "en-id";
        this.dateFormat = {
            short: "dd/MM/yyyy",
            medium: "d MMMM yyyy",
            long: "dddd, d MMMM yyyy",
        };
        this.currencyFormat = {
            code: "IDR",
            symbol: "Rp",
            decimalSeparator: "",
            groupSeparator: ".",
            positivePattern: "C n",
            negativePattern: "-C n"
        };
    }
}
exports.EnIdIdr = EnIdIdr;
